import axios from "axios";
import { useSettingsStore } from "@/stores/settings";
import Document from "@/models/Documents/Document";
import FileHelper from "@/helpers/utilities/FileHelper";

export const quickshare_actions = {
  async loadQuickShareDocuments() {
    const settingsStore = useSettingsStore();

    const configForApiRequest = {
      headers: {
        apikey: import.meta.env.VITE_APP_UCHI_API_KEY,
        "x-functions-key": import.meta.env.VITE_APP_UCHI_FUNCTION_KEY,
        sessiontoken: settingsStore.quickShareSessionToken
      }
    };

    const url = `${import.meta.env.VITE_APP_UCHI_API_ENDPOINT}/shares/${settingsStore.quickShareKey}/files`;

    const response = await axios.get(url, configForApiRequest);
    this.quickShareDocumentsState = response.data.map(qsDocument => {
      const document = Document.fromQuickShare(
        qsDocument,
        import.meta.env.VITE_APP_UCHI_API_ENDPOINT + "/shares/" + settingsStore.quickShareKey
      );
      document.itemId = qsDocument.graphItemId;
      document.createdDateTime = qsDocument.createdWhen;
      document.extension = FileHelper.getFileExtensionObject(document.name);
      return document;
    });
  },

  async downloadQuickShareDocument(itemId) {
    const settingsStore = useSettingsStore();

    const configForApiRequest = {
      headers: {
        apikey: import.meta.env.VITE_APP_UCHI_API_KEY,
        "x-functions-key": import.meta.env.VITE_APP_UCHI_FUNCTION_KEY,
        sessiontoken: settingsStore.quickShareSessionToken,
        Accept: "application/octet-stream"
      },
      responseType: "blob",
      onDownloadProgress: progressEvent => {
        this.downloadProgressState[itemId] = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
      }
    };

    const progressBefore = JSON.parse(JSON.stringify(this.downloadProgressState));
    progressBefore[itemId] = -1;
    this.downloadProgressState = progressBefore;

    const blobResponse = await axios.get(
      `${import.meta.env.VITE_APP_UCHI_API_ENDPOINT}/shares/${settingsStore.quickShareKey}/files/${itemId}`,
      configForApiRequest
    );
    const progressAfter = this.downloadProgressState;
    progressAfter[itemId] = null;
    this.downloadProgressState = progressAfter;

    return blobResponse.data;
  },

  async downloadQuickShareDocumentsAsZip() {
    const settingsStore = useSettingsStore();

    const configForApiRequest = {
      headers: {
        apikey: import.meta.env.VITE_APP_UCHI_API_KEY,
        "x-functions-key": import.meta.env.VITE_APP_UCHI_FUNCTION_KEY,
        sessiontoken: settingsStore.quickShareSessionToken,
        Accept: "application/octet-stream"
      },
      responseType: "blob",
      onDownloadProgress: progressEvent => {
        this.downloadProgressState["Samlet Zip"] = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
      }
    };

    const progressBefore = JSON.parse(JSON.stringify(this.downloadProgressState));
    progressBefore["Samlet Zip"] = -1;
    this.downloadProgressState = progressBefore;

    const blobResponse = await axios.get(
      `${import.meta.env.VITE_APP_UCHI_API_ENDPOINT}/shares/${settingsStore.quickShareKey}/zip`,
      configForApiRequest
    );

    const progressAfter = this.downloadProgressState;
    progressAfter["Samlet Zip"] = null;
    this.downloadProgressState = progressAfter;
    return blobResponse.data;
  }
};

export const quickshare_getters = {
  quickShareDocuments(state) {
    return state.quickShareDocumentsState;
  },

  downloadProgress(state) {
    return state.downloadProgressState;
  }
};

export const quickshare_state = {
  quickShareDocumentsState: null,
  downloadProgressState: {}
};
